import Button from "@components/ui/Atom/Button";
import procurarImg from "@images/PROCURAR.png";

interface NoDiariosMessageProps {
  handleClearFiltro: Function;
}

export const NoDiariosMessage = ({handleClearFiltro}: NoDiariosMessageProps) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        gap: 20,
      }}
    >
      <img src={procurarImg} alt="imagem error" width={150} />
      <p
        style={{
          textAlign: "center",
          fontSize: 20,
          fontWeight: "bold",
          color: "#ccc8c8",
          textTransform: "uppercase",
        }}
      >
        Não há diários disponíveis <br /> para o filtro selecionado
      </p>
      <Button
        style={{marginTop: -15}}
        onClick={() => {
          handleClearFiltro();
        }}
      >
        Limpar filtro
      </Button>
    </div>
  );
};
